import { ArrowUpRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { LocalizedLink } from '@/components/LocalizedLink'
import type { PublicCategoryRecord } from '@/data/public-catalog'

export function CategoryCard({ category, productCount }: { category: PublicCategoryRecord; productCount: number }) {
  const { t } = useTranslation('common')
  const title = t(`categories.${category.id}`)
  return <article className="catalog-category-card">
    <LocalizedLink to={category.id} className="catalog-category-link">
      <div className="catalog-category-image">
        <img src={category.media} alt={t('catalog.categoryImageAlt', { category: title })} loading="lazy" decoding="async" />
      </div>
      <div className="catalog-category-copy">
        <p className="catalog-card-kind">{t('catalog.categoryKind')}</p>
        <h2>{title}</h2>
        <div className="catalog-card-footer">
          <span>{t('catalog.productCount', { count: productCount })}</span>
          <span className="catalog-card-action">{t('catalog.viewCategory')}<ArrowUpRight aria-hidden="true" size={21} /></span>
        </div>
      </div>
    </LocalizedLink>
  </article>
}
